
import createIcon from "./createIcon";

export const LoaderIcon = createIcon('Loader', ({ className = '', ...props }) => {
  return (
    <svg className={
      [
        "animate-spin",
        className,
      ].join(' ')
    } {...props} viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 12a9 9 0 1 1-6.219-8.56" />
    </svg >
  )
});
